import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import { useState } from 'react';
import { C_INPUT__collection_name } from './C_INPUT__collection_name';
import { C_LIST_ITEM__collection } from './C_LIST_ITEM__collection';

interface Props {
  item: DTO__collection;
}

export function C_LIST_ITEM__collection_master({ item }: Props) {
  const [is_edit_name, set_is_edit_name] = useState(false);

  return is_edit_name ? <C_INPUT__collection_name {...{ set_is_edit_name, item }} /> : <C_LIST_ITEM__collection {...{ set_is_edit_name, item }} />;
}
